import React, { Fragment } from "react"
import "./src/assets/main.scss"
import DataCollect from "./src/data/data-collect"
import "./src/fontello/css/fontello.css"

export const wrapRootElement = ({ element }) => {
  DataCollect.init()
  return <Fragment>{element}</Fragment>
}
